import { Prisma, prisma } from "client";
export const getChargeAdjustmentById = async (id: string) => {
  try {
    const chargeAdjustment = await prisma.chargeAdjustment.findFirst({
      where: {
        id: id,
      },
    });

    return chargeAdjustment;
  } catch (error) {
    console.error("Error fetching charge adjustment by ID:", error);
    throw error;
  }
};
export const getChargeAdjustment = async (
  eventId: string,
  page: number = 1,
  pageSize: number = 10,
  search?: string
) => {
  try {
    const skip = (page - 1) * pageSize;
    const take = pageSize;
    let whereClause: Prisma.ChargeAdjustmentWhereInput = {};

    if (search) {
    }
    return (
      await prisma.chargeAdjustment.findMany({
        where: whereClause,
        orderBy: {
          id: "desc",
        },
        skip: skip,
        take: take,
      }),
      prisma.chargeAdjustment.count({
        where: whereClause,
      })
    );
  } catch (error) {
    console.error("Error fetching charge adjustment:", error);
    throw error;
  }
};
export const createChargeAdjustment = async (
  data: Prisma.ChargeAdjustmentCreateInput,
  eventId: string,
  adjustmentRuleId: string
) => {
  try {
    return await prisma.chargeAdjustment.create({
      data: {
        ...data,
        event: {
          connect: {
            id: eventId,
          },
        },
        adjustmentRule: {
          connect: {
            id: adjustmentRuleId,
          },
        },
      },
    });
  } catch (error) {
    console.error("Error creating charge adjustment:", error);
    throw error;
  }
};
export const updateChargeAdjustment = async (
  id: string,
  data: Prisma.ChargeAdjustmentUpdateInput
) => {
  try {
    return await prisma.chargeAdjustment.update({ where: { id }, data });
  } catch (error) {
    console.error("Error updating charge adjustment:", error);
    throw error;
  }
};
